var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steam"},[_vm._t("error")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }